import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { QuoteCountry } from '~/lib/types/basket-types';
import { useCallback } from 'react';

export function useCountryTranslations() {
  const { t } = useTranslation([TranslationNamespaces.COUNTRY]);

  const translateCountry = useCallback(
    (country: QuoteCountry) => {
      return t(`Country_${country.iso3Code}`, { defaultValue: country.name });
    },
    [t]
  );

  return { translateCountry };
}
